$(function() {


  /*
   * VARIABLES
   ***********************************/
  var $item    = $('.js-navigation-item'),
      $chapter = $('.js-chapter'),
      margin   = $win.outerHeight();



  /*
   * INIT
   ***********************************/

  $win.on('scroll', function() {
    var scrollTop = $win.scrollTop();

    $chapter.each(function() {
      var $this = $(this),
          $section = $this.parents('.js-section'),
          id    = $this.attr('id'),
          $item = $('.js-navigation-item[data-id=' + id + ']'),
          start = $this.offset().top - margin,
          end   = (start + $this.outerHeight()) + margin / 2;

      if(scrollTop >= start && scrollTop < end) {
        $section.addClass('is-active');

        if($item.length > 0) {
          $item.addClass('is-active');
        }
      }
      else {
        $section.removeClass('is-active');

        if($item.length > 0) {
          $item.removeClass('is-active');
        }
      }
    });
  });

});
